/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSVersicherung from '../../models/TSVersicherung';

export default class VersicherungRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API', '$log', '$q'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, private $log: ILogService, private $q: IQService) {
        this.serviceURL = REST_API + 'versicherungen';
        this.http = $http;
    }

    public findActiveVersicherungen(): IPromise<TSVersicherung[]> {
        let config = {cache: true};
        return this.http.get(this.serviceURL, config)
            .then((response: any) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING versicherungen REST  object', response.data);
                    return TSVersicherung.deserializeArray(response.data);
                } else {
                    return [];
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/versicherungRS.rest.ts